var _path, _path2, _path3, _path4, _path5, _filter;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolder = function SvgFolder(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.08,
    d: "M15 43.444C15 31.111 19.083 27 31.333 27h16.334c8.166 0 16.333 8.222 24.5 8.222h24.5c12.25 0 16.333 4.111 16.333 16.445v32.888C113 96.89 108.917 101 96.667 101H31.333C19.083 101 15 96.889 15 84.555z",
    style: {
      fill: "#000",
      fillOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg_icon_Folder__filter0_dd_2253_14934)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE26E",
    d: "M16 44c0-12 4-16 16-16h16c8 0 16 8 24 8h24c12 0 16 4 16 16v32c0 12-4 16-16 16H32c-12 0-16-4-16-16z",
    style: _defineProperty(_defineProperty({
      fill: "#ffe26e"
    }, "fill", "color(display-p3 1 .8863 .4314)"), "fillOpacity", 1)
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_Folder__paint0_linear_2253_14934)",
    fillOpacity: 0.04,
    d: "M16 44c0-12 4-16 16-16h16c8 0 16 8 24 8h24c12 0 16 4 16 16v32c0 12-4 16-16 16H32c-12 0-16-4-16-16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_Folder__paint1_linear_2253_14934)",
    fillOpacity: 0.24,
    d: "M16 44c0-12 4-16 16-16h16c8 0 16 8 24 8h24c12 0 16 4 16 16v32c0 12-4 16-16 16H32c-12 0-16-4-16-16z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.08,
    d: "M16 44c0-12 4-16 16-16h16c8 0 16 8 24 8h24c12 0 16 4 16 16v32c0 12-4 16-16 16H32c-12 0-16-4-16-16z",
    style: {
      fill: "#000",
      fillOpacity: 0.08
    }
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE26E",
    d: "M16 56c0-8 3-12 11-12h73q12 0 12 12v28c0 12-4 16-16 16H32c-12 0-16-4-16-16z",
    style: _defineProperty(_defineProperty({
      fill: "#ffe26e"
    }, "fill", "color(display-p3 1 .8863 .4314)"), "fillOpacity", 1)
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_Folder__paint2_linear_2253_14934)",
    fillOpacity: 0.16,
    d: "M16 56c0-8 3-12 11-12h73q12 0 12 12v28c0 12-4 16-16 16H32c-12 0-16-4-16-16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_Folder__paint3_linear_2253_14934)",
    fillOpacity: 0.08,
    d: "M16 56c0-8 3-12 11-12h73q12 0 12 12v28c0 12-4 16-16 16H32c-12 0-16-4-16-16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_Folder__paint4_linear_2253_14934)",
    fillOpacity: 0.08,
    d: "M16 56c0-8 3-12 11-12h73q12 0 12 12v28c0 12-4 16-16 16H32c-12 0-16-4-16-16z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_Folder__paint0_linear_2253_14934",
    x1: 64,
    x2: 64,
    y1: 50,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_Folder__paint1_linear_2253_14934",
    x1: 64,
    x2: 64,
    y1: 55,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_Folder__paint2_linear_2253_14934",
    x1: 64,
    x2: 64,
    y1: 44,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_Folder__paint3_linear_2253_14934",
    x1: 64,
    x2: 64,
    y1: 44,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_Folder__paint4_linear_2253_14934",
    x1: 64,
    x2: 64,
    y1: 44,
    y2: 59.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "svg_icon_Folder__filter0_dd_2253_14934",
    width: 112,
    height: 88,
    x: 8,
    y: 28,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2253_14934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2253_14934",
    result: "effect2_dropShadow_2253_14934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2253_14934",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolder);
export { ForwardRef as ReactComponent };